import axios from "axios";
import {environmentConfig} from "@/config/enviromentConfig";

const safaricomHeaders = {Authorization: `Basic ${environmentConfig.safaricomAuthHeader}`};

export default class LoginService {
    static async sendOTP(msisdn, revenuePartnerId) {
        return await axios.post(`${environmentConfig.upstreamIntegrationService}/user-authentication/request-otp`, {
            msisdn: msisdn,
            revenuePartnerId: revenuePartnerId
        })
    }

    static async validateOTP(msisdn, otp) {
        return await axios.post(`${environmentConfig.upstreamIntegrationService}/user-authentication/validate-otp`, {
            msisdn: msisdn,
            otp: otp,
        })
    }

    static async trackLogin(msisdn, revenuePartnerId) {
        return await axios.post(`${environmentConfig.upstreamIntegrationService}/track-login`, {
            msisdn: msisdn,
            revenuePartnerId: revenuePartnerId,
            isFantasy: 1,
            isScorePredictor: 0,
            isWeb: 1
        })
    }

    static async getUserViaProductId(productId, msisdn) {
        const response = await axios.post(`${environmentConfig.upstreamAisHost}/user/get-user-via-product-id`, {
            productId: productId,
            msisdn: msisdn,
        })
        return response.data;
    }

    static async trackAisUserLogin(productId, msisdn) {
        return await axios.post(`${environmentConfig.upstreamAisHost}/user/track-user-login`, {
            productId: productId,
            msisdn: msisdn,
            isWeb: true,
        })
    }

    static async sendSafaricomOTP(msisdn, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/request-otp`, {
            msisdn: Number(msisdn),
            productId: productId
        }, {headers: safaricomHeaders})
    }

    static async validateSafaricomOTP(msisdn, productId, otp) {
        return await axios.post(`${environmentConfig.safaricomService}/validate-otp`, {
            msisdn: Number(msisdn),
            productId: productId,
            otp: otp,
        }, {headers: safaricomHeaders})
    }

    static async getSafaricomUser(msisdn, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/get-user`, {
            msisdn: Number(msisdn),
            productId: productId,
        }, {headers: safaricomHeaders})
    }

    static async getTelkomSaUser(msisdn, productId) {
        return await axios.post(`${environmentConfig.safaricomService}/get-user`, {
            msisdn: Number(msisdn),
            productId: productId,
        }, {headers: safaricomHeaders})
    }

    static async subscribeSafaricom(msisdn) {
        return await axios.post(`${environmentConfig.safaricomService}/subscribe`, {
            msisdn: Number(msisdn),
        }, {headers: safaricomHeaders})
    }
}
